import React from 'react'
import ProductsPage from './ProductsPage'

const Brands = () => {
  return <ProductsPage pageType="brands" />
}

export default Brands
